/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastseenrecently2Inputs */



/**
* | output |
* | --- |
* | "last seen: recently" |
*
* @param {Lastseenrecently2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const lastseenrecently2 = /** @type {((inputs?: Lastseenrecently2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastseenrecently2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("last seen: recently")
	if (locale === "es") return /** @type {LocalizedString} */ ("últ. vez: hace poco")
	return /** @type {LocalizedString} */ ("в сети: недавно")
});
export { lastseenrecently2 as "lastSeenRecently" }